import * as React from "react";

const CompanyLogos = () => {
  const logos = [
    {
      src: "https://cdn.builder.io/api/v1/image/assets/TEMP/82a9f25b1d7df9e1e458755d4f69e71afc0bcbd0242cba5dfdb3430528b2057c?placeholderIfAbsent=true&apiKey=5e33e1e8f3e04cd39cce5570222ab698",
      width: "154px",
      aspect: "3.85",
    },
    {
      src: "https://cdn.builder.io/api/v1/image/assets/TEMP/bea7c8fe5054553547282f1f6a0558a1f2dc7f5a2812c2cb40c4e665ac18b79d?placeholderIfAbsent=true&apiKey=5e33e1e8f3e04cd39cce5570222ab698",
      width: "82px",
      aspect: "2.56",
    },
    {
      src: "https://cdn.builder.io/api/v1/image/assets/TEMP/7bf289c5ee3cfc7dcbfdf8f4fc9d2192ca9779be8be6a29985e721d5db28dfbe?placeholderIfAbsent=true&apiKey=5e33e1e8f3e04cd39cce5570222ab698",
      width: "183px",
      aspect: "7.63",
    },
    {
      src: "https://cdn.builder.io/api/v1/image/assets/TEMP/bb1fa8db169eb040370ed98f662f3bf5d0701f41f3bac598fc7308598dc4546a?placeholderIfAbsent=true&apiKey=5e33e1e8f3e04cd39cce5570222ab698",
      width: "116px",
      aspect: "4.15",
    },
    {
      src: "https://cdn.builder.io/api/v1/image/assets/TEMP/b05b9a1a9363f1a3b9842be50df994608c934dd3de5128341186f524ae00ee57?placeholderIfAbsent=true&apiKey=5e33e1e8f3e04cd39cce5570222ab698",
      width: "108px",
      aspect: "3.38",
    },
  ];

  return (
    <div className="flex flex-wrap gap-10 justify-between items-center mt-8 w-full max-md:max-w-full max-sm:gap-6 max-sm:mt-4">
      {logos.map((logo, index) => (
        <figure key={index} style={{ width: logo.width }}>
          <img
            src={logo.src}
            alt="Company logo"
            className="object-contain shrink-0"
            style={{ aspectRatio: logo.aspect }}
          />
        </figure>
      ))}
    </div>
  );
};

export default CompanyLogos;
